/* eslint-disable @typescript-eslint/no-explicit-any */
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Text,
  VStack,
  Box,
} from '@chakra-ui/react';
import { CPFInput, Input } from '../atoms/Input';
import { Button } from '../atoms/Button';
import { useEffect } from 'react';

const schema = z.object({
  cpf: z.string().nonempty('CPF é obrigatório'),
  email: z.string().email('Email inválido').nonempty('Email é obrigatório'),
});

const ModalCompleteProfile = ({
  isOpen,
  onClose,
  profileData,
  updateProfile,
}: {
  isOpen: boolean;
  profileData: any;
  updateProfile: (data: Record<string, string | boolean>) => void;
  onClose: () => void;
}) => {
  const profile = profileData?.profile;
  const { register, handleSubmit, setValue } = useForm({ resolver: zodResolver(schema) });

  useEffect(() => {
    if (profile?.cpf) {
      setValue('cpf', profile?.cpf);
    } else {
      setValue('email', profile?.email);
    }
  }, [profile]);

  const onSubmit = (data: any) => {
    const payload: any = {};
    if (!profile?.cpf) {
      payload.cpf = data.cpf.replace(/\D/g, '');
    }
    if (!profile?.email) {
      payload.email = data.email;
    }
    updateProfile(payload);
  };

  return (
    <Modal isOpen={isOpen} onClose={() => {}} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Complete seu Perfil</ModalHeader>
        <ModalBody>
          <Text>Para visualizar, você precisa concluir seu cadastro:</Text>
          <VStack spacing={4} mt={4}>
            <CPFInput placeholder="Digite seu CPF" isReadOnly={profile?.cpf} {...register('cpf')} />
            <Input placeholder="Digite seu Email" {...register('email')} />
            <ModalFooter width={'100%'}>
              <Box width={'100%'}>
                <Button onClick={handleSubmit(onSubmit)} width={'100%'}>
                  Concluir
                </Button>
              </Box>
            </ModalFooter>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ModalCompleteProfile;
